<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import Loading from "@/components/c-loading";
import { propertyService } from "../../../services/propertyservice/property.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { bookingtransferService } from "../../../services/bookingservice/bookingtransfer.service";
import i18n from "../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Booking Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    Select,
    Search
  },
  watch: {
      valueExtend: function(newVal) { // watch it
        // console.log(newVal);
        let deposit = parseFloat(this.valueBookingAmount);
        let extend = parseFloat(newVal);

        this.valueLastBookingAmount = deposit + extend;
      }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Booking",
      breadCrumb: {},
      
      booking: {},
      propertySelected: {},
      propertyData: {},
      valueTransferDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueBookingId: 0,
      valueFromProperty: '',
      valueFromPropertyId: 0,
      valueToProperty: '',
      valueToPropertyId: 0,
      valueCustomer: '',
      valueCustomerId: 0,
      valueBookingAmount: 0,
      valueNotation: '',

      valuePaymentMethod: 1,
      paymentMethodData: [],
      valueBankAccount: 0,
      bankAccountData: [],

    };
  },
  mounted() {

    this.loadingPropertyData();

    this.valuePaymentMethod = 1;

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }

    // console.log(this.$moment().clone().format('YYYY-MM-DD'));
    // console.log(this.valueTransferDate);
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      bookingService.getOne(id)
        .then(response => {

          this.fetchingStats = true;
          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };
          
            this.booking = response;
            this.valueBookingId = response.data.id;
            this.valueFromProperty = response.data.property;
            this.valueFromPropertyId = response.data.property_id;
            this.valueCustomer = `${response.data.customer} (${response.data.customer_en})`;
            this.valueCustomerId = response.data.customer_id;
            this.valueBookingAmount = response.data.booking_amount;
            this.valueNotation = response.data.notation;
            
          }

          this.loadingSettings(response.setting);
        
        });
    },

    loadingSettings: function(setting) {

      this.paymentMethodData = {data: setting.paymentmethods};
      this.bankAccountData = {data: setting.bankaccounts};
    },

    loadingPropertyData: function(projectId = 0, groupId = 0) {

      propertyService.getAvailable(projectId, groupId).then(response => {
        this.propertyData = response;
      });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
          });

        }
      });
    },
    
    submitSave: function() {

      this.tryingToSubmit = true;

      let bookingTransfer = {
        
        
        booking_id: this.valueBookingId,
        from_property_id: this.valueFromPropertyId,
        to_property_id: this.valueToPropertyId,
        booking_amount: this.valueBookingAmount,
        notation: this.valueNotation,
        booking_transfer_status_id: 1,
        for_date: this.valueTransferDate,
        payment_method_id: this.valuePaymentMethod,
        bank_account_id: this.valueBankAccount
      };

      // console.log(this.valueTransferDate, JSON.stringify(bookingTransfer));

      bookingtransferService.insert(bookingTransfer)
        .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {

            if(response.data) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {

                    this.$router.push(this.$route.query.redirectFrom || {
                      name: "booking-list"
                    });

                    // let route = this.$router.resolve({ path: `/general/booking/receipt/${response.data.id}` });
                    // window.open(route.href);
                } 
              });
            } else {
              this.$swal.fire({
                title: i18n.t('general.invalid.title'),
                text: i18n.t('general.invalid.message'),
                icon: "error",
                confirmButtonColor: "#34c38f",
                confirmButtonText: i18n.t('general.ok')
              }).then(result => {
                if (result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "booking-list"
                  });
                } 
              });
            }
          }
        
      });
      
    },

    clearForm: function() {
      this.valueBookingId = 0;
      this.valueFromProperty = '';
      this.valueFromPropertyId = 0;
      this.valueToProperty = '';
      this.valueToPropertyId = 0;
      this.valueCustomer = '';
      this.valueCustomerId = 0;
      this.valueBookingAmount = 0;
      this.valueNotation = '';
      this.valueTransferDate = this.$moment().clone().format('YYYY-MM-DD');
      this.valuePaymentMethod = 0;
      this.valueBankAccount = 0;
    },

    paymentMethodChanged: function(event) {

      if(event != 2 && event != 3) {
        this.valueBankAccount = 0;
      }
    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('booking.list'),
        href: '/general/booking',
      }, {
        text: $t('booking.transfer-property.text'),
        active: true
      }]" :title="$t('booking.transfer-property.text')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('booking.list'),
        href: '/general/booking',
      }, this.breadCrumb]" :title="$t('booking.transfer-property.text')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">

              <div class="row">
                <!-- <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="valueCode"
                    :label="'booking.code'"
                     /> 
                </div> -->
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'from_property_id'"
                    :disabled="true"
                    v-model="valueFromProperty"
                    :label="'booking.transfer-property.from'"
                     /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'customer_id'"
                    :disabled="true"
                    v-model="valueCustomer"
                    :label="'customer.text'"
                     /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'booking_amount'"
                    :disabled="true"
                    v-model="valueBookingAmount"
                    :label="'booking.deposit'"
                     /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'date'"
                    :id="'booking_date'"
                    v-model="valueTransferDate"
                    :label="'general.date'" 
                     /> 
                </div>
                <div class="col-md-8">
                  <Search 
                    :id="'property_id'"
                    :text="'code'"
                    v-model="valueToPropertyId"
                    :editable="false"
                    :list="this.propertyData"
                    :label="'booking.transfer-property.to'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select
                    @change="paymentMethodChanged" 
                    :id="'payment_method_id'"
                    :auto="true"
                    v-model="valuePaymentMethod"
                    :list="this.paymentMethodData"
                    :label="'booking.payment-method'"
                     /> 
                </div>
                <div v-show="valuePaymentMethod == 2 || valuePaymentMethod == 3" class="col-md-6">
                  <Select
                    :id="'bank_account_id'"
                    v-model="valueBankAccount"
                    :list="this.bankAccountData"
                    :label="'payment.bank_account'"
                     /> 
                </div>
              </div>
              <div class="row">
                <!-- <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'notation'"
                    v-model="valueNotation"
                    :label="'booking.notation'"  />
                </div> -->
              </div>

              <div class="row" style="margin-top: 15px;">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                  <Area 
                    :rows="12"
                    :id="'notation'"
                    v-model="valueNotation"
                    :label="'booking.notation'"  />
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-form> 

  </Layout>
</template>